import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import { useState, useEffect } from 'react';
import debounce from '../utils/debounce.js';

var getIsMobile = function getIsMobile() {
  return typeof window !== 'undefined' && window.innerWidth < 768;
};
function useIsMobile(initialIsMobile) {
  var _useState = useState(initialIsMobile || getIsMobile()),
    _useState2 = _slicedToArray(_useState, 2),
    isMobile = _useState2[0],
    setIsMobile = _useState2[1];
  useEffect(function () {
    var onResize = debounce(function () {
      setIsMobile(getIsMobile());
    }, 500);
    if (typeof window !== 'undefined') {
      onResize();
      window.addEventListener('resize', onResize);
    }
    return function () {
      if (typeof window !== 'undefined') {
        window.removeEventListener('resize', onResize);
      }
    };
  }, []);
  return isMobile;
}

export { useIsMobile as default };
//# sourceMappingURL=useIsMobile.js.map
